document.addEventListener("DOMContentLoaded", function() {


    function equalizeHeights(selector) {
        const element = document.querySelectorAll(selector);
        let maxHeight = 0;


        element.forEach(el => {
            el.style.height = "auto";
        })

        element.forEach(el => {
            const height = el.offsetHeight;
            if(height > maxHeight) {
                maxHeight = height;
            }
        })

        element.forEach(el => {
            el.style.height = maxHeight + 'px';
        })

    }

    equalizeHeights('.tst__text');
    equalizeHeights('.tst__review-title');

    window.addEventListener("load", function() {
        equalizeHeights('.tst__text');
        equalizeHeights('.tst__review-title');
    })

    window.addEventListener("resize", function() {
        equalizeHeights('.tst__text');
        equalizeHeights('.tst__review-title');
    })

});